import React, { memo } from "react";
import _ from "lodash";

import classNames from "classnames";
import useI18n from "Hooks/UseI18n";

import { useDispatch } from "Hooks/useDispatch";
import {
  DragAndDropList,
  Dropdown,
  IconButton,
  Tooltip,
} from "@toddle-edu/ds-web";
import { SettingsOutlined } from "@toddle-edu/ds-icons";

import { onFilterPreferenceChange } from "../../Utils/ThreadListModule";

import classes from "./ColumnConfigureButton.scss";

const ColumnConfigurationPopover = ({ filterButtons }) => {
  const dispatch = useDispatch();
  const { t } = useI18n(["common"]);

  const onFilterChange = newFilterState => {
    dispatch(
      onFilterPreferenceChange({
        filterPreference: {
          showFilter: _.map(_.filter(newFilterState, "isSelected"), "id"),
          filterDisplayOrder: _.map(newFilterState, "id"),
        },
      })
    );
  };

  return (
    <div className={classes.popoverContainer}>
      <div className={classNames(classes.popoverHeaderText, "text-label")}>
        {t("common:manage_tabs")}
      </div>
      <div className={classes.popoverContent}>
        <DragAndDropList
          value={filterButtons}
          dndKey="manageColumnsFilter"
          mode="view"
          listType={"checklist"}
          showSeparator={false}
          showAddAnotherItemButton={false}
          showDeleteItemButton={false}
          onValueChange={onFilterChange}
          alwaysShowDragIcon
          dsVersion="2.0"
        />
      </div>
    </div>
  );
};

const ColumnConfigureButton = props => {
  const { filterButtons } = props;
  const { t } = useI18n(["common"]);

  return (
    <Dropdown
      overlay={<ColumnConfigurationPopover filterButtons={filterButtons} />}
    >
      <Tooltip tooltip={t("common:manage_filters")} placement="right">
        <IconButton
          icon={<SettingsOutlined />}
          dsVersion="2.0"
          type="outlined"
          size="small"
          variant="neutral"
        />
      </Tooltip>
    </Dropdown>
  );
};

export default memo(ColumnConfigureButton);
